<h3 mat-dialog-title>How Apps Are Scored (CMDB Data)</h3>
<mat-dialog-content>
    <div class="scoring-legend-content">
        <p class="legend-intro">
            This assessment is based on application data synced from Chevron's CMDB.
            The AI analysis evaluates the following CMDB fields to determine the modernization recommendation.
        </p>

        <div class="section-heading">Exclusion Rules (always applied first)</div>
        <table class="legend-table">
            <tbody>
                <tr><td class="legend-label">Not in use</td><td>LifeCycleStageStatus ≠ "In Use"</td></tr>
                <tr><td class="legend-label">SaaS / COTS</td><td>HostingType or ManagementStyle contains SaaS / COTS</td></tr>
                <tr><td class="legend-label">Sensitive data</td><td>DataClassification = Personal Data / Sensitive Personal Data</td></tr>
                <tr><td class="legend-label">End of life</td><td>PlannedDisposition or Status contains retire / decommission / EOL</td></tr>
            </tbody>
        </table>

        <div class="section-divider"></div>

        <div class="section-heading">Modernization Score (1–100)</div>
        <table class="legend-table">
            <tbody>
                <tr><td class="legend-label">Baseline</td><td>+10</td></tr>
                <tr><td class="legend-label">Hosting</td><td>On-Premise / Desk +35 · Hybrid +25 · IaaS +15 · PaaS +0</td></tr>
                <tr><td class="legend-label">Management</td><td>HomeGrown +20</td></tr>
                <tr><td class="legend-label">Architecture</td><td>Legacy (client_server, n_tier…) +20 · Blank +5 · Modern +0</td></tr>
                <tr><td class="legend-label">Lifecycle</td><td>Deprecated +10 · Maintenance +5</td></tr>
                <tr><td class="legend-label">Tech debt</td><td>Description contains "legacy / monolithic / technical debt…" +10</td></tr>
                <tr><td class="legend-label">Legacy tech</td><td>TechnologyStack matches deprecated list +15</td></tr>
                <tr><td class="legend-label">No migration plan</td><td>MigrationStrategy blank +5</td></tr>
            </tbody>
        </table>

        <div class="section-divider"></div>

        <div class="section-heading">Decommission Score (1–100)</div>
        <table class="legend-table">
            <tbody>
                <tr><td class="legend-label">Baseline</td><td>+30</td></tr>
                <tr><td class="legend-label">Functional overlap</td><td>Description contains "duplicate / alternative to…" +40</td></tr>
                <tr><td class="legend-label">Low usage</td><td>Description contains "limited users / rarely used…" +30</td></tr>
                <tr><td class="legend-label">Micro utility</td><td>HostingType=Desk or "internal utility / team tool…" +20</td></tr>
                <tr><td class="legend-label">Replacement signal</td><td>Description contains "replaced by / transitional…" +20</td></tr>
            </tbody>
        </table>

        <div class="section-divider"></div>

        <div class="section-heading">Final Outcome Rules</div>
        <table class="legend-table">
            <tbody>
                <tr>
                    <td><span class="outcome-badge modernize">Modernize</span></td>
                    <td>ModernizationScore ≥ 30 AND ≥ DecommissionScore</td>
                </tr>
                <tr>
                    <td><span class="outcome-badge already-modern">Already Modern</span></td>
                    <td>ModernizationScore &lt; 30 AND DecommissionScore ≤ 50; or PaaS with score &lt; 60</td>
                </tr>
                <tr>
                    <td><span class="outcome-badge excluded">Excluded</span></td>
                    <td>Section 1 triggered; or DecommissionScore ≥ 50 AND &gt; ModernizationScore</td>
                </tr>
            </tbody>
        </table>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="btn" (click)="onClose()">Close</button>
</mat-dialog-actions>
